import { render, staticRenderFns } from "./deco-homes.vue?vue&type=template&id=497ecd84&scoped=true"
import script from "./deco-homes.vue?vue&type=script&lang=js"
export * from "./deco-homes.vue?vue&type=script&lang=js"
import style0 from "./deco-homes.vue?vue&type=style&index=0&id=497ecd84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ecd84",
  null
  
)

export default component.exports